import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface ISupplierFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		code?: any;
		taxCodeId?: any;
		name?: any;
		sisproSupplierTimestamp?: any;
		sisproSupplierExtTimestamp?: any;
		sisproSupplierAddrTimestamp?: any;
		sisproName?: any;
		sisproShortName?: any;
		branch?: any;
		contact?: any;
		telephone?: any;
		fax?: any;
		email?: any;
		beeRating?: any;
		beeExpiryDate?: any;
		beeCompanyRegistration?: any;
		companyRegNo?: any;
		address1?: any;
		address2?: any;
		address3?: any;
		address4?: any;
		address5?: any;
		addressContact?: any;
		postalAddress1?: any;
		postalAddress2?: any;
		postalAddress3?: any;
		postalAddress4?: any;
		postalAddress5?: any;
		postalAddressContact?: any;
}

export class SupplierFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public code: IEntityModelField = { name: "code", displayName: "Code", fieldType: FieldType.String, pattern: "NameGeneric" };
	public taxCodeId: IEntityModelField = { name: "taxCodeId", displayName: "Tax Code Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public name: IEntityModelField = { name: "name", displayName: "Name", fieldType: FieldType.String, pattern: "NameGeneric" };
	public sisproSupplierTimestamp: IEntityModelField = { name: "sisproSupplierTimestamp", displayName: "Sispro Supplier Timestamp", fieldType: FieldType.String, pattern: "NameGeneric" };
	public sisproSupplierExtTimestamp: IEntityModelField = { name: "sisproSupplierExtTimestamp", displayName: "Sispro Supplier Ext Timestamp", fieldType: FieldType.String, pattern: "NameGeneric" };
	public sisproSupplierAddrTimestamp: IEntityModelField = { name: "sisproSupplierAddrTimestamp", displayName: "Sispro Supplier Addr Timestamp", fieldType: FieldType.String, pattern: "NameGeneric" };
	public sisproName: IEntityModelField = { name: "sisproName", displayName: "Sispro Name", fieldType: FieldType.String, pattern: "NameGeneric" };
	public sisproShortName: IEntityModelField = { name: "sisproShortName", displayName: "Sispro Short Name", fieldType: FieldType.String, pattern: "NameGeneric" };
	public branch: IEntityModelField = { name: "branch", displayName: "Branch", fieldType: FieldType.String, pattern: "NameGeneric" };
	public contact: IEntityModelField = { name: "contact", displayName: "Contact", fieldType: FieldType.String, pattern: "NameGeneric" };
	public telephone: IEntityModelField = { name: "telephone", displayName: "Telephone", fieldType: FieldType.String, pattern: "NameGeneric" };
	public fax: IEntityModelField = { name: "fax", displayName: "Fax", fieldType: FieldType.String, pattern: "NameGeneric" };
	public email: IEntityModelField = { name: "email", displayName: "Email", fieldType: FieldType.String, pattern: "NameGeneric" };
	public beeRating: IEntityModelField = { name: "beeRating", displayName: "BEERating", fieldType: FieldType.String, pattern: "NameGeneric" };
	public beeExpiryDate: IEntityModelField = { name: "beeExpiryDate", displayName: "BEEExpiry Date", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public beeCompanyRegistration: IEntityModelField = { name: "beeCompanyRegistration", displayName: "BEECompany Registration", fieldType: FieldType.String, pattern: "NameGeneric" };
	public companyRegNo: IEntityModelField = { name: "companyRegNo", displayName: "Company Reg No", fieldType: FieldType.String, pattern: "NameGeneric" };
	public address1: IEntityModelField = { name: "address1", displayName: "Address1", fieldType: FieldType.String, pattern: "NameGeneric" };
	public address2: IEntityModelField = { name: "address2", displayName: "Address2", fieldType: FieldType.String, pattern: "NameGeneric" };
	public address3: IEntityModelField = { name: "address3", displayName: "Address3", fieldType: FieldType.String, pattern: "NameGeneric" };
	public address4: IEntityModelField = { name: "address4", displayName: "Address4", fieldType: FieldType.String, pattern: "NameGeneric" };
	public address5: IEntityModelField = { name: "address5", displayName: "Address5", fieldType: FieldType.String, pattern: "NameGeneric" };
	public addressContact: IEntityModelField = { name: "addressContact", displayName: "Address Contact", fieldType: FieldType.String, pattern: "NameGeneric" };
	public postalAddress1: IEntityModelField = { name: "postalAddress1", displayName: "Postal Address1", fieldType: FieldType.String, pattern: "NameGeneric" };
	public postalAddress2: IEntityModelField = { name: "postalAddress2", displayName: "Postal Address2", fieldType: FieldType.String, pattern: "NameGeneric" };
	public postalAddress3: IEntityModelField = { name: "postalAddress3", displayName: "Postal Address3", fieldType: FieldType.String, pattern: "NameGeneric" };
	public postalAddress4: IEntityModelField = { name: "postalAddress4", displayName: "Postal Address4", fieldType: FieldType.String, pattern: "NameGeneric" };
	public postalAddress5: IEntityModelField = { name: "postalAddress5", displayName: "Postal Address5", fieldType: FieldType.String, pattern: "NameGeneric" };
	public postalAddressContact: IEntityModelField = { name: "postalAddressContact", displayName: "Postal Address Contact", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.code);
		this.push(this.taxCodeId);
		this.push(this.name);
		this.push(this.sisproSupplierTimestamp);
		this.push(this.sisproSupplierExtTimestamp);
		this.push(this.sisproSupplierAddrTimestamp);
		this.push(this.sisproName);
		this.push(this.sisproShortName);
		this.push(this.branch);
		this.push(this.contact);
		this.push(this.telephone);
		this.push(this.fax);
		this.push(this.email);
		this.push(this.beeRating);
		this.push(this.beeExpiryDate);
		this.push(this.beeCompanyRegistration);
		this.push(this.companyRegNo);
		this.push(this.address1);
		this.push(this.address2);
		this.push(this.address3);
		this.push(this.address4);
		this.push(this.address5);
		this.push(this.addressContact);
		this.push(this.postalAddress1);
		this.push(this.postalAddress2);
		this.push(this.postalAddress3);
		this.push(this.postalAddress4);
		this.push(this.postalAddress5);
		this.push(this.postalAddressContact);
	}
}

export class SupplierDTO implements IEntityModel {
	protected supplierName: string = "SupplierModel";
	protected supplierKeyField: string = "id";
	protected supplierDisplayName: string = "Supplier|Suppliers";
	protected supplierFields = new SupplierFields();
	public get name(): string { return this.supplierName };
	public get keyField(): string { return this.supplierKeyField };
	public get displayName(): string { return this.supplierDisplayName };
	public get fields(): SupplierFields { return this.supplierFields };

	constructor() {};
}
